import { createI18n } from "vue-i18n";

const i18n = createI18n({
  locale: "ar", // set locale
  fallbackLocale: "en", // set fallback locale
  messages: {
    en: require("./locales/en.json"),
    ar: require("./locales/ar.json"),
  },
});

export default i18n;
